import React, { useMemo } from 'react';

import { PromoCodeInput } from './Payments/PromoCodeInput';
import { useTranslations } from 'next-intl';

import { PromoCodeResult, TransformedSubscription } from '@/api/types/user.types';

import { AmountTypeEnum } from '@/enums/promocodes.enums';
import { PeriodEnum } from '@/enums/subscription-type.enums';

import { useStore } from '@/contexts/StoreContext';
import styles from '@/contexts/VerificationContext/VerificationModal/SubscriptionVerification/PromoCodeSection.module.scss';

// =================================================================

interface PromoCodeSectionProps {
  promoCodeResponse: PromoCodeResult[];
  selectedSubscription: TransformedSubscription;
}
// =================================================================

export const PromoCodeSection = (props: PromoCodeSectionProps) => {
  const { promoCodeResponse, selectedSubscription } = props;

  const t = useTranslations();

  const { subscriptionPeriod } = useStore(store => store.subscriptionStore);

  const matchedPromo = useMemo(() => {
    if (!promoCodeResponse || !selectedSubscription) return null;
    if (selectedSubscription?.period[subscriptionPeriod].promo_code) {
      return {
        discount: selectedSubscription?.period[subscriptionPeriod].promo_code?.amount,
        tariff_title: selectedSubscription?.title,
        days: selectedSubscription?.period[subscriptionPeriod].days,
        discount_type: selectedSubscription?.period[subscriptionPeriod].promo_code?.amount_type,
      };
    }
    return promoCodeResponse.find(
      tariff =>
        tariff.tariff_id === selectedSubscription.id &&
        ((tariff.days === 30 && subscriptionPeriod === PeriodEnum.Month) ||
          (tariff.days !== 30 && subscriptionPeriod === PeriodEnum.Year)),
    );
  }, [promoCodeResponse, selectedSubscription, subscriptionPeriod]);

  return matchedPromo && selectedSubscription ? (
    <div className={styles.promoCodeContainer}>
      <p>
        {t('verification.promoCodeApplied', {
          period:
            matchedPromo.days === 30
              ? t('page.userProfile.promoCodes.monthly')
              : t('page.userProfile.promoCodes.annual'),
          tariff: matchedPromo.tariff_title ?? '',
          discount:
            matchedPromo.discount_type === AmountTypeEnum.PERCENT
              ? matchedPromo.discount + '%'
              : matchedPromo.discount + t('page.userProfile.sum'),
        })}
      </p>
    </div>
  ) : (
    <PromoCodeInput />
  );
};
